import React from 'react'

const SvgPinFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M14.554 19.172l1.15-1.107a2.484 2.484 0 00.748-2.048l-.187-1.778 2.51-2.51c2.35.37 4.376-2.845 2.579-4.642l-4.389-4.388c-1.814-1.815-5.058.264-4.632 2.63l-2.49 2.49-1.81-.187a2.484 2.484 0 00-2.012.715L4.87 9.499a2.484 2.484 0 00.023 3.535l2.171 2.144-4.68 4.68a1.25 1.25 0 001.769 1.767l4.69-4.69 2.233 2.204a2.484 2.484 0 003.48.033z' />
  </svg>
)

export default SvgPinFilled
